import React, { useEffect, useRef, useState } from 'react';
import { SELFHOST_INSTALL_COMMAND, STUDIO_HERO_DOWNLOADS } from 'utils/installLinks';
import './HeroInstall.css';

/**
 * HeroInstall — the hero's call to action over the office scene: the one
 * self-host install command with a Copy button, and the Zibby Studio
 * downloads under it (utils/installLinks). `data-office-anchor` marks it for HeroOffice, which
 * places the office relative to it.
 */
const CopyIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="9" y="9" width="13" height="13" rx="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);
const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 6 9 17l-5-5" />
  </svg>
);
const DownloadIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 3v12M7 10l5 5 5-5M5 21h14" />
  </svg>
);

export default function HeroInstall() {
  const [copied, setCopied] = useState(false);
  const copiedTimer = useRef(null);

  useEffect(() => () => clearTimeout(copiedTimer.current), []);

  const copy = () => {
    navigator.clipboard?.writeText(SELFHOST_INSTALL_COMMAND);
    setCopied(true);
    clearTimeout(copiedTimer.current);
    copiedTimer.current = setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="hero-install" data-office-anchor>
      <div className="hero-install__eyebrow">Run it on your own machine</div>
      <div className="hero-install__bar">
        <span className="hero-install__prompt" aria-hidden="true">$</span>
        <code className="hero-install__cmd">{SELFHOST_INSTALL_COMMAND}</code>
        <button type="button" className={`hero-install__copy${copied ? ' is-copied' : ''}`} onClick={copy}>
          {copied ? <CheckIcon /> : <CopyIcon />}
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <div className="hero-install__studio">
        <span>or download Teamy Studio</span>
        <a href={STUDIO_HERO_DOWNLOADS.mac}><DownloadIcon />macOS</a>
        <a href={STUDIO_HERO_DOWNLOADS.windows}><DownloadIcon />Windows</a>
      </div>
    </div>
  );
}
